import { AlertStatus } from "src/types/alert";

export const isAlertInProgress = (alert: { status: AlertStatus }) => {
  return alert.status === "assigned" || alert.status === "notAssigned";
};
